// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond40: FC<Diamond40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M20.055 35.667 5.083 20.917l8.25-10.056H26.75l8.278 10.056-14.973 14.75ZM7.347 10.083l-3.18-3.125 1.986-2 3.152 3.18-1.958 1.946Zm11.32-3.277V2.333h2.778v4.473h-2.778Zm13.986 3.278-1.958-1.959 3.18-3.18 1.958 2.013-3.18 3.126ZM20.055 31.777l9.75-9.611h-19.5l9.75 9.611Zm-5.388-18.14-4.737 5.75h20.25l-4.735-5.75H14.667Z" />
        </svg>
    );
};

export default Diamond40;
